import React from 'react';

import { withTranslation } from 'react-i18next';
import Parent from '../parent';
import {BllinkLogger} from '../utils/bllink_loggers';
import { constants } from "../constants/constants";
import './oneTimeSinglePayment.css';
import InstallmentsBox from "./InstallmentsBox";
import $ from 'jquery';

export class OneTimePaymentSingleSection extends Parent {

    constructor(props) {
        super(props);
        BllinkLogger.info('constructor OneTimePaymentSingleSection ', props);
        const payment = props.payment || {};
        this.state = {
            payment: payment,
            index: props.index,
            currency: payment.amount_left.currency
        }
        this.typeOfPayment = constants.cache.keys.payments.oneTimePayments;
    }

    async componentDidMount() {
        await this.bindDoubleClickToAddOrEdit()
        const thisObj = this;
        $(document).ready(function () {
            thisObj.bindPopUpClicks(thisObj, 'oneTime')
        });
    }

    async bindDoubleClickToAddOrEdit(){
        const isViewedAsManager = await this.isLoggedIn(); //opening for all managers, requested by rayee via email
        // const isViewedAsManager = await this.isAdmin(); //just as a first step
        if (isViewedAsManager) {
            let thisObj = this;
            $('.amount-in-box').unbind('dblclick').bind('dblclick', function (e) {
                thisObj.handlePartPayDoubleClicked(e)
            })
        }
    }


    render() {

        const data = {isOneTime: true}

        return (
                <div key={this.state.index} className="col-md-4 p-third js-one-time-parent" building-one-time-id={this.state.payment.building_one_time_payment_id}>
                    <div className="inline_layout-2">
                        <label className="label_container-2">
                            <input checked={this.props.payment.selected}
                                   onChange={this.props.onChanged}
                                   className="jquery-oneTimeCheckBox"
                                   type="checkbox" />
                            <span className="checkmark-2"/>
                            {this.state.payment.payment_description}

                        </label>
                    </div>
                    <p className="pr-4 one-time-description">{this.state.payment.payment_long_description}</p>
                    <InstallmentsBox
                        partPay={this.state.payment.part_pay}
                        total={this.state.payment.amount_left.value}
                        maxNumberOfInstallments={this.state.payment.max_installments}
                        currency={this.state.currency}
                        name={constants.cache.keys.payments.oneTimeInstallmentsName(this.state.payment.building_one_time_payment_id)}
                        data={data}
                        isViewedAsManager={this.props.isViewedAsManager}
                        shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        isOneTime={true}
                        onChanged={this.props.onMethodChanged}
                    />
                </div>
        )

    }
}

export default withTranslation()(OneTimePaymentSingleSection);
